<template>
    <div class="d-flex flex-grow-1 flex-column align-items-center justify-content-center">
        <span class="scv-text-wait-feedback scv-text-default-color-main-FRONTENDEX-MOBILE-APP">
            アプリカタログの表示の準備を行っています。
        </span>
        <span class="scv-text-wait-feedback scv-text-default-color-main-FRONTENDEX-MOBILE-APP">
            準備には数分かかります。
        </span>
        <span class="scv-text-wait-feedback scv-text-default-color-main-FRONTENDEX-MOBILE-APP">
            しばらくお待ちください。
        </span>

        <div style="height: 8px;"></div>
        <span class="scv-text-wait-feedback-sub scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">
            ※準備処理は認証後の初回のみ行います。
        </span>
    </div>

</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';

    @Options({
        emits: [
            /**
             * @brief	タイムアウトイベント
             */
            "onTimer"
        ]
    })

    export default class AppCatalogWaitFeedbackView extends Vue {
        private nTimerID: number | undefined = undefined;

        /**
         * マウント後の処理
         */
        public mounted(): void {
            this.TimerSet();
        }

        /**
         * 終了時の処理
         */
        public unmounted(): void {
            if (undefined != this.nTimerID) {
                clearTimeout(this.nTimerID);
                this.nTimerID = undefined;
            }
        }

        /**
         * タイマー発火
         */
        private onTimerEvent(): void {
            this.nTimerID = undefined;

            // 親へ通知
            this.$emit("onTimer");
        }

        /**
         * タイマー設定
         */
        public TimerSet(): void {
            this.nTimerID = window.setTimeout(this.onTimerEvent, 5000);
        }

    }
</script>

<style scoped>
    .scv-text-wait-feedback {
        font-size: 15px;
    }

    .scv-text-wait-feedback-sub {
        font-size: 13px;
    }
</style>